import { useState, useEffect } from "react";
import Styles from "../../styles.module.scss"
import SideMenu from "../../sideMenu";
import DashboardHeader from "../../dashboardHeader"
import * as CONSTANTS from '../../../../utils/CONSTANTS';
import { makeSideBarActive } from '../../../../utils/EllowUtils';
import Button from "../../../../components/button";
import Headline5 from "../../../../components/headings/Headline5";
import RatingStatus from "./ratingStatus"
import RequestRating from "../../../../modals/requestRating";
import { Icon } from '@iconify/react';
import { getAssessmentRequestHistory ,  saveAssessmentRequestDetails , sendRatingReminder } from "./services"
import NotificationAlert from "../../../../components/notification";
import mixpanelData from "../../../../utils/mixpanel";

function MyRatings(props : any ) {

    const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 5)
    const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "") || {}
    const loginId: string = localStorage.getItem('loginId') || ''
    
    const [modal , setModal] = useState<Boolean>(false)
    const [data , setData] = useState()
    const [notification, setNotification] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')

    useEffect(() =>{
        assessmentRequestHistory(loginId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const requestRating = () => {
        setModal(true)
    }

    const assessmentRequestHistory = (loginId: any) => {
        getAssessmentRequestHistory(loginId).then((response) => {
            if(response.status === 1){
                setData(response.data)
            }
        })
    }

    const saveAssessmentDetails = (data: any) => {
        let value = {
            "loginId":  loginId,
            "userLoginId": null,
            "customerId": null,
            "companyName": data.companyName,
            "designation": data.designation,
            "candidateName": profileMetadata.firstName+" "+profileMetadata.lastName,
            "contractStartDate": data.contractStartDate.toString(),
            "contractEndDate": data.contractEndDate.toString(),
            "email": data.email,
            "emailBody": data.emailBody,
            "submittedBy":"FREELANCER"
        }
        saveAssessmentRequestDetails(value).then((response) => {
            if(response && response.status === 1){
                setModal(false)
                displayNotification("Details saved successfully")
                assessmentRequestHistory(loginId)
                mixpanelData('MWP - Ratings requested', {
                    'distinct_id':  profileMetadata && profileMetadata.email,
                    'Candidate email': profileMetadata && profileMetadata.email,
                    'Email of the employer': data.email,
                    'Company name': data.companyName,
                    'Candidate Designation': data.designation,
                    'Contract start date': data.contractStartDate && new Date(data.contractStartDate).toDateString(),
                    'Contract End date': data.contractEndDate && new Date(data.contractEndDate).toDateString()
                })    
                mixpanelData('New MWP - Ratings requested', {
                    'distinct_id':  profileMetadata && profileMetadata.email,
                    'Candidate email': profileMetadata && profileMetadata.email,
                    'Email of the employer': data.email,
                    'Company name': data.companyName,
                    'Candidate designation': data.designation,
                    'Contract start date': data.contractStartDate && new Date(data.contractStartDate).toDateString(),
                    'Contract end date': data.contractEndDate && new Date(data.contractEndDate).toDateString(),
                    "Candidate loginId":  loginId,
                })
            }
            else{   
                setModal(false)
                displayNotification("Please give a different Company or Designation")
            }
        })    
    }

    const sendReminder = (body: any) => { 
        sendRatingReminder(body).then((response) => {
            if (response && response.status === 1) { 
                displayNotification('Reminder sent successfully')
                assessmentRequestHistory(loginId)
                mixpanelData('New MWP - Rating reminder sent', {
                    'distinct_id':  profileMetadata && profileMetadata.email,
                    "Candidate loginId":  loginId,
                    'Candidate email': profileMetadata && profileMetadata.email,
                    'Email of the employer': response.data[0].email,
                    'Company name': response.data[0].companyname,
                    'Candidate designation': response.data[0].positionname,
                    'Contract start date': response.data[0].contractStartDate && new Date(parseInt(response.data[0].contractStartDate)).toDateString(),
                    'Contract end date': response.data[0].contractendDate && new Date(parseInt(response.data[0].contractendDate)).toDateString(),
                })
            }
        })
    }

    const displayNotification = (message: string) => {
        setMessage(message)
        setNotification(true)
        setTimeout(() => {
           setNotification(false)
        }, 4000);
    }

    return (
      <section className={Styles.dashboardWrapper}>
        <SideMenu menu={menu} />
        <div className={Styles.dashboardContent}>
            <DashboardHeader/>
            <div className="headWrap">
                <div className="headingWrap">
                    <Headline5>My Ratings</Headline5>
                    <div className="subtext">Request ratings from your previous employers to increase your profile visibility</div>
                </div>
                <Button variant="primary" onClick={() => {requestRating()}}><Icon className="btnIcon" icon="ant-design:star-outlined" /> Request Rating</Button>
            </div>
            <div className="contentBox mb-40">
                <div className="innerPadd24">
                    <RatingStatus data={data} sendReminder={sendReminder}/>
                </div>
            </div>
        </div>
        {modal && <RequestRating clickHandler={saveAssessmentDetails} onClose={() => setModal(false)} />}
        {notification && <NotificationAlert onClose={() => setNotification(false) } closable={true} >{message}</NotificationAlert> }
      </section>
    )
}
export default MyRatings
